import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostEmailLogin = () => {
  return useMutation({
    mutationFn: authService.postEmailLogin,
    throwOnError: false,
  });
};
